import { useContext, useEffect } from 'react';
import { useRouter } from 'next/router';
import { ScreenSizeContext, withScreenSizeProvider } from '../../../../../../context/ScreenSizeContext';
import PreviewToolbar from '../../../../../../components/PreviewToolbar';
import withAuthenticationRequired from '../../../../../../utils/jwt/withAuthenticationRequired';
import { LOGIN_PATH } from '../../../../../../constants';
import usePreviewLink from '../../../../../../utils/usePreviewLink';
import { ItemPageDataContext, ItemPageDataProvider } from '../../../../../../data/itemPageData/context';
import { useGetPageQuery } from '../../../../../../store';
import { useSpaceAndPageIDFromRouter } from '../../../../../../data/space/hooks';

function Preview() {
  const router = useRouter();

  const {
    data_id: dataID,
  } = router.query;

  const [spaceID, pageID] = useSpaceAndPageIDFromRouter();

  const { data: page } = useGetPageQuery([spaceID, pageID]);
  const pageSchema = page?.customization?.item_page_data?.pageSchema;

  const { itemData, getItemPageDataForPage } = useContext(ItemPageDataContext);

  useEffect(() => {
    if (page) {
      getItemPageDataForPage(spaceID as string, page, dataID as string);
    }
  }, [page]);

  const previewLink = usePreviewLink(itemData?.[pageSchema?.slug]);

  const currentScreenSize = useContext(ScreenSizeContext);

  return (
    <div style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: '100vh',
    }}
    >
      <PreviewToolbar />
      <div style={{
        width: currentScreenSize.width,
        height: currentScreenSize.height,
        boxShadow: 'var(--shadow-navbar)',
        border: '1px solid var(--border-modal)',
        borderRadius: 10,
      }}
      >
        {
          itemData
          && <iframe id="typedream-preview-iframe" title="preview title" src={previewLink} height="100%" width="100%" style={{ borderRadius: 10 }} />
        }
      </div>
    </div>
  );
}
const ScreenSizedPreview = withScreenSizeProvider(Preview);

export default withAuthenticationRequired(() => (
  <ItemPageDataProvider>
    <ScreenSizedPreview />
  </ItemPageDataProvider>
), { loginPagePath: LOGIN_PATH });
